import { Alert, Skeleton } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { useNotifications } from '@app-velocity/libs/notifications';

import { NotificationsList } from '../../../../../components/NotificationsList';

export const MyNotifications = () => {
  const { t } = useI18n();

  const { myInvitations, isLoading } = useNotifications();

  if (isLoading)
    return (
      <>
        <Skeleton height={60} borderRadius={4} />
        <Skeleton height={60} borderRadius={4} />
        <Skeleton height={60} borderRadius={4} />
      </>
    );

  if (!myInvitations) return null;

  if (myInvitations.length === 0)
    return (
      <Alert severity="info">{t('users:notifications.no_notifications')}</Alert>
    );

  return <NotificationsList notifications={myInvitations} />;
};
